import { AppSettings } from '../constants/constants';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { Observable, throwError } from 'rxjs'
import { catchError, map, share } from 'rxjs/operators';
import { HttpClient } from 'selenium-webdriver/http';
import { DeviceDetectorService } from 'ngx-device-detector';


@Injectable(
   {
      providedIn: 'root'
   }
)
export class DhukanDataService {
   deviceInfo = null;
   ipAddress: any;

   constructor(private http: Http, private deviceService: DeviceDetectorService) {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      // this.fnGetIpAddress();
      console.log(this.deviceInfo)
   }

   fnpostInputParams(url, params) {
      const headers = new Headers({
         //'Content-Type': "application/JSON",
         // 'token': (sessionStorage.rbookadtoken === undefined) ? '' : JSON.parse(sessionStorage.rbookadtoken)                
      });


      return this.http.post(AppSettings.base_url + url, params, { headers: headers });
   }



   getProductDetailsByEmenu(params) {

      return this.fnpostInputParams(AppSettings.getproductdetailsbyemenuUrl, params);
   }


   getSalesDetailsByEbill(params) {

      return this.fnpostInputParams(AppSettings.getsalesdetailsbyebillUrl, params);
   }

   getQuestionDetailsFeedback(params) {

      return this.fnpostInputParams(AppSettings.getquesiondetailsfeedbackUrl, params);
   }
   
   fnInsertfeedback(params) {

      return this.fnpostInputParams(AppSettings.insertfeedbackUrl, params);
   }

   
   getProductDetailsByQrmenu(params) {

      return this.fnpostInputParams(AppSettings.getproductdetailsbyqrmenuUrl, params);
   }


   // customer Register
   CheckCustomer(params) {
      return this.fnpostInputParams(AppSettings.checkcustomer, params);
   }
   InsertCustomerse(params) {
      return this.fnpostInputParams(AppSettings.insertcustomerse, params);
   }
   getCustomerse(params) {
      return this.fnpostInputParams(AppSettings.getcustomeres, params);
   }
   setCustomer(params) {
      return this.fnpostInputParams(AppSettings.setcustomeres, params);
   }

   // store
   getStoreSynccode(params) {
      return this.fnpostInputParams(AppSettings.getstoresynccode, params);
   }
   checkAddons(params) {
      return this.fnpostInputParams(AppSettings.checkaddons, params);
   }
   
   // Question Main
   insertQuestionmain(params) {
      return this.fnpostInputParams(AppSettings.insertQuestionmainUrl, params);
   }
   getQuestionmain(params) {
      return this.fnpostInputParams(AppSettings.getQuestionmainUrl, params);
   }
   // Question Choices Details
   insertQuestionchoicesdetails(params) {
      return this.fnpostInputParams(AppSettings.insertQuestionchoicesdetailsUrl, params);
   }
   getQuestionchoicesdetails(params) {
      return this.fnpostInputParams(AppSettings.getQuestionchoicesdetailsUrl, params);
   }
   // Feedback Main
   insertFeedbackmain(params) {
      return this.fnpostInputParams(AppSettings.insertFeedbackmainUrl, params);
   }

   getFeedbackmain(params) {
      return this.fnpostInputParams(AppSettings.getFeedbackmainUrl, params);
   }
   // Feedback Details
   insertFeedbackDetails(params) {
      return this.fnpostInputParams(AppSettings.insertFeedbackdetailsUrl, params);
   }
   getFeedbackdetailsList(params) {
      return this.fnpostInputParams(AppSettings.getFeedbackdetailsListUrl, params);
}
// QRCODE
getQRCode(params) {
      return this.fnpostInputParams(AppSettings.getQRCodeUrl, params);
   }
}
